import React from 'react'
import { css } from '@emotion/react'
import { CollectionsList } from 'domains/collections/components/collections-list/components/list/CollectionsList'
import { type ChildCollection } from 'domains/collections/types/collections.types'
import { useChildCollectionsListColumns } from './utils/childCollectionsListColumns.hooks'

export interface CollectionsListProps {
  collections: ChildCollection[]
  onDelete: (collectionId: string) => void
}

const wrapper = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: 350,
})

export const CollectionsChildCollectionsList: React.FunctionComponent<CollectionsListProps> = ({
  collections,
  onDelete,
}) => {
  const columns = useChildCollectionsListColumns({ onDelete })

  return (
    <div css={wrapper}>
      <CollectionsList
        columns={columns}
        collections={collections ?? []}
        apiLoading={false}
        apiError={undefined}
        canLoadMore={false}
        loadMore={undefined}
        refetch={undefined}
      />
    </div>
  )
}
